import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const comparisonAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: true, max: 80 },
  { name: 'subheadline', type: 'string', required: false, max: 200 },
  { name: 'usLabel', type: 'string', required: true, max: 24 },
  { name: 'themLabel', type: 'string', required: true, max: 24 },
  {
    name: 'rows',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'feature', type: 'string', required: true, max: 80 },
      { name: 'us', type: 'string', required: true, max: 60 },
      { name: 'them', type: 'string', required: true, max: 60 },
    ],
  },
];

export const comparisonUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: 'Headline', required: true, max: 80 },
  { name: 'subheadline', type: 'textarea', label: 'Subheadline', max: 200 },
  { name: 'usLabel', type: 'text', label: 'Us label', required: true, max: 24 },
  { name: 'themLabel', type: 'text', label: 'Them label', required: true, max: 24 },
  { name: 'rows', type: 'comparison_rows', label: 'Comparison rows', required: true },
];

export const comparisonZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().min(1).max(80),
  subheadline: z.string().max(200).optional().nullable(),
  usLabel: z.string().max(24),
  themLabel: z.string().max(24),
  rows: z
    .array(
      z.object({
        feature: z.string().max(80),
        us: z.string().max(60),
        them: z.string().max(60),
      }),
    )
    .min(2),
});

export type ComparisonContent = z.infer<typeof comparisonZodSchema>;

export const comparisonSample: ComparisonContent = {
  eyebrow: 'Why us',
  headline: 'See the difference.',
  subheadline: 'A clear-eyed look at how we compare.',
  usLabel: 'Atlas',
  themLabel: 'Other',
  rows: [
    { feature: 'Setup time', us: 'Under 10 minutes', them: '2-3 hours' },
    { feature: 'Real-time collaboration', us: 'Built-in', them: 'Add-on' },
    { feature: 'Pricing', us: 'Transparent', them: 'Sales-led' },
    { feature: 'Open standards', us: 'Yes', them: 'Proprietary' },
  ],
};
